import { useEffect, useRef } from "react";

const useClickOutsideModal = (onClose) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleMouseDown = (event) => {
      if (!modalRef.current) {
        return;
      }

      if (!modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleMouseDown);

    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, [onClose]);

  return modalRef;
};

export default useClickOutsideModal;
